import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SquareLocation } from 'src/app/services/square-pos.service';

@Component({
  selector: 'app-square-location-picker',
  templateUrl: './square-location-picker.component.html',
  styleUrls: ['./square-location-picker.component.scss'],
})
export class SquareLocationPickerComponent implements OnInit {
  @Output() locationPick: EventEmitter<SquareLocation> = new EventEmitter<SquareLocation>();

  constructor() { }

  ngOnInit() {}
  onLocationPicked(location: SquareLocation) {
    this.locationPick.emit(location);
  }

}
